angular.module('picmonic-common').factory('UserService', [
  '$cookies',
  '$q',
  '$filter',
  '$state',
  '$location',
  '$modal',
  'User',
  'MarketOptionsConfig',
  'ngBowser',
  'FacebookService',
  'RaygunService',
  'PendoService',
  'SalesforceChatService',
  'ReferralDataService',
  '$http',
  'SplitTestService',
  function (
    $cookies,
    $q,
    $filter,
    $state,
    $location,
    $modal,
    User,
    MarketOptionsConfig,
    ngBowser,
    FacebookService,
    RaygunService,
    PendoService,
    SalesforceChatService,
    ReferralDataService,
    $http,
    SplitTestService
  ) {
    return {
      user: new User(window.pls_config.user),
      cancelRecommended: $q.defer(),
      recommendationPromise: false,

      getRecommendations: function () {
        var self = this;
        if (self.recommendationPromise) {
          self.recommendationPromise.$cancelRequest();
        }
        self.recommendationPromise = User.recommended(
          { type: 'browse' },
          { timeout: self.cancelRecommended },
          function (data) {
            self.recommended = data;
          }
        );

        return this.recommendationPromise;
      },

      recommended: false,

      setCookieIfNotLoggedIn: function (name, value) {
        var self = this;
        if (!self.user.user_id) {
          $cookies.put('pls_user_' + name, value);
        }
      },

      quizSplitText: function () {
        var self = this;
        if (self.user.beta_user_flag) {
          return true;
        } else {
          var show_quiz_cookie = $cookies.get('pls_user_show_quiz');
          if (!show_quiz_cookie) {
            return false;
          } else {
            if (show_quiz_cookie == 'true') {
              return true;
            } else {
              return false;
            }
          }
        }
      },

      generateTypeFormURL: function (typeFormId, extraParams) {
        var self = this;
        var url = 'https://truelearn.typeform.com/to/' + typeFormId;
        var params = [
          'user_id=' + self.user.user_id,
          'email=' + encodeURIComponent(self.user.email),
          'vertical=' + self.user.lead,
          'subscription_type=' + (self.user.is_trial ? 'Free' : 'Paid'),
          'subscription_exp=' +
            encodeURIComponent($filter('date')(new Date(self.user.expiration * 1000), 'MM-dd-yyyy hh:mm a')),
          'school_name=' + encodeURIComponent(self.user.school ? self.user.school.name : ''),
          'cards_mastered=' + self.user.cards_mastered,
          'os=' + encodeURIComponent(ngBowser.os.name),
          'browser=' + encodeURIComponent(ngBowser.browser.name),
          'grad_year=' + (self.user.graduation_year ? self.user.graduation_year : ''),
        ];

        if (extraParams) {
          params = params.concat(extraParams);
        }

        url += '?' + params.join('&');

        return url;
      },
      checkForReferral: function () {
        var self = this;

        // PALife Hack
        if ($location.search().palife) {
          $cookies.put('referrer_code', 'ZPIRM1MC13IY');
        }

        // Osmosis Hack
        if ($location.search().osmosis) {
          $cookies.put('referrer_code', 'VCNRXY4ONK9M');
        }

        // Check if the logged user has already made a connection
        if (self.user.user_id && self.user.is_referred) {
          ReferralDataService.init();
          return true;
          // Check the url params
        } else if ((referrerCode = $location.search().ref || $location.search().afl || $location.search().amb)) {
          $cookies.put('referrer_code', referrerCode);
          ReferralDataService.init(referrerCode);
          return true;
          // Check the cookies
        } else if ((referrerCode = $cookies.get('referrer_code'))) {
          ReferralDataService.init(referrerCode);
          return true;
        }

        return false;
      },
      checkIsInNorthAmerica: function () {
        const NA_COUNTRIES = ['US', 'MX', 'BM', 'PM', 'UM', 'GL', 'CA'];

        return $http
          .get('https://ipinfo.io')
          .then(response => NA_COUNTRIES.includes(response.data.country))
          .catch(e => false);
      },
      getReferralParam: function (type) {
        var self = this;

        const getCorrectShareAppend = () => {
          if (self.user.role === 'Affiliate' && self.user.affiliate.affiliate_type === 'Ambassador') {
            return 'amb';
          }

          if (self.user.role === 'Affiliate') {
            return 'afl';
          }

          return 'ref';
        };

        return getCorrectShareAppend() + '=' + self.user.referrer_code + self.getReferralSuffix(type);
      },
      getFullReferralUrl: function (type, user) {
        var self = this;

        user = user ? user : self.user;

        var pathArray = location.href.split('/');
        var protocol = pathArray[0];
        var host = pathArray[2];
        var url = protocol + '//' + host;

        return (
          url +
          (user.role === 'Affiliate'
            ? user.affiliate.affiliate_type === 'Ambassador'
              ? '/ambassadorhookup/'
              : '/viphookup/'
            : '/insiderhookup/') +
          user.referrer_code +
          self.getReferralSuffix(type)
        );
      },
      getReferralSuffix: function (type) {
        var date = new Date();
        var month = $filter('date')(date, 'M');
        var month_char = String.fromCharCode(parseInt(month, 10) + 96).toUpperCase();
        var day = $filter('date')(date, 'd');
        var day_char;
        if (day > 26) {
          day_char = parseInt(day, 10) - 26;
        } else {
          day_char = String.fromCharCode(parseInt(day, 10) + 96).toUpperCase();
        }

        var type_code = 'L';
        switch (type) {
          case 'facebook':
            type_code = 'F';
            break;
          case 'twitter':
            type_code = 'T';
            break;
          case 'email':
            type_code = 'E';
            break;
          default:
          case 'link':
            type_code = 'L';
            break;
        }

        return type_code + month_char + day_char + $filter('date')(date, 'yy');
      },
      socialRegister: function (redirect, redirectUrl) {
        return this.socialLogin(redirect, true, redirectUrl);
      },
      socialLogin: function (redirect, register, redirectUrl) {
        var self = this;

        self.user.accessToken = null;

        if (navigator.userAgent.indexOf('Crosswalk') > -1 || navigator.userAgent.indexOf('CriOS') > -1) {
          document.location.href =
            'https://www.facebook.com/dialog/oauth?client_id=491312997564602&scope=email&redirect_uri=https://' +
            window.location.host +
            '/register/social';
        } else {
          return FacebookService.login().then(function (data) {
            self.user.accessToken = data.authResponse.accessToken;
            if (register) {
              return self.register(redirect, redirectUrl);
            } else {
              return self.login(redirect, redirectUrl);
            }
          });
        }
      },
      googleRegister: function (redirect, redirectUrl) {
        return this.googleLogin(redirect, true, redirectUrl);
      },
      googleLogin: function (redirect, register, redirectUrl) {
        var self = this;
        self.user.google_id_token = null;
        return $q(function (resolve, reject) {
          gapi.auth2.authorize(
            {
              client_id: pls_config.google_client_id,
              scope: 'email profile openid',
              response_type: 'id_token permission',
            },
            function (response) {
              if (response.error) {
                if (register) {
                  reject(response);
                } else {
                  window.location =
                    'https://accounts.google.com/o/oauth2/v2/auth?client_id=' +
                    pls_config.google_client_id +
                    '&response_type=code&scope=email profile openid&redirect_uri=' +
                    window.location.origin +
                    '/login/google';
                }
              } else {
                resolve(response);
              }
            }
          );
        }).then(function (data) {
          self.user.google_id_token = data.id_token;
          if (register) {
            return self.register(redirect, redirectUrl);
          } else {
            return self.login(redirect, redirectUrl);
          }
        });
      },
      register: function (redirect, redirectUrl) {
        redirect = typeof redirect != 'undefined' ? redirect : true;
        redirectUrl = typeof redirectUrl != 'undefined' ? redirectUrl : null;
        var self = this;

        self.user.registerSource = ngBowser.isMobile() ? 'mobile-web' : 'desktop';
        self.user.registration_source_device = ngBowser.getPlatformType();
        self.user.registration_source_browser = ngBowser.browser.name;
        self.user.resource = '';
        self.user.timezone = moment.tz.guess();

        return self.user.$save(function (data) {
          var urlparams = $location.search();
          RaygunService.setRayGunUserInfo(self.user);
          PendoService.setUserInfo(self.user);
          SalesforceChatService.setUserInfo(self.user);

          if (typeof atlasEvent !== 'undefined' && !data.alreadyExists) {
            send_ga('event', 'Register', 'Web-App Registration', data.lead);
            atlasEvent('register', data.lead, 'new_user');

            var tracking = new Image();
            tracking.src =
              '//www.googleadservices.com/pagead/conversion/941316450/?label=0ctSCPS2k2QQ4rLtwAM&guid=ON&script=0';
            var fbtracking = new Image();
            fbtracking.src = 'https://www.facebook.com/tr?id=759705864106825&ev=CompleteRegistration&noscript=1';
            var quoratracking = new Image();
            quoratracking.src =
              'https://q.quora.com/_/ad/192a17be5d6849eabeea173c0a2d2fbd/pixel?tag=CompleteRegistration';

            // Adwords Signup Conversion
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'trackSignup',
            });

            // Bing Conversion Event
            window.uetq = window.uetq || [];
            window.uetq.push({
              ec: 'Register',
              ea: 'Web-App Registration',
              el: data.lead,
              ev: 0,
            });
          }

          if (redirect) {
            if (data.alreadyExists) {
              if (urlparams.redirect) {
                if (urlparams.redirect.indexOf('/') === 0) {
                  urlparams.redirect = urlparams.redirect.substring(1);
                }
                if (urlparams.redirect.indexOf('%2F') === 0) {
                  urlparams.redirect = urlparams.redirect.substring(3);
                }
                top.location = '/' + urlparams.redirect;
              } else {
                urlparams.browseOpen = 1;
                top.location = '/home?' + $.param(urlparams);
              }
            } else if (urlparams.skip_school && urlparams.redirect && data.role && data.lead) {
              if (urlparams.redirect.indexOf('/') === 0) {
                urlparams.redirect = urlparams.redirect.substring(1);
              }
              if (urlparams.redirect.indexOf('%2F') === 0) {
                urlparams.redirect = urlparams.redirect.substring(3);
              }
              top.location = '/' + urlparams.redirect;
            } else if (redirectUrl) {
              if (redirectUrl.indexOf('/') === 0) {
                redirectUrl = redirectUrl.substring(1);
              }
              if (redirectUrl.indexOf('%2F') === 0) {
                redirectUrl = redirectUrl.substring(3);
              }
              top.location = '/' + redirectUrl;
            } else if (
              data.role &&
              data.lead &&
              (data.program || !MarketOptionsConfig.getProgramsByMarketId(data.lead))
            ) {
              $location.url('/register/step3?' + $.param(urlparams));
            } else {
              $location.url('/register/step2?' + $.param(urlparams));
            }
          }
        });
      },
      login: function (redirect, redirectUrl) {
        redirect = typeof redirect != 'undefined' ? redirect : true;
        redirectUrl = typeof redirectUrl != 'undefined' ? redirectUrl : null;
        var self = this;

        if (self.user.lti) {
          atlasEvent('click', 'lti_tos_login');
          var lti = 1;
        }

        return self.user.$login(function (data) {
          self.deleteApiKey();
          var urlparams = $location.search();
          RaygunService.setRayGunUserInfo(self.user);
          PendoService.setUserInfo(self.user);
          SalesforceChatService.setUserInfo(self.user);

          if (lti) {
            atlasEvent('completed', 'lti_tos_login');
            atlasEvent('completed', 'lti_tos_modal');
          }

          if (redirect) {
            if (!data.lead || !data.role) {
              $location.url('/login/step2?' + $.param(urlparams));
            } else if (!data.school) {
              $location.url('/login/step3?' + $.param(urlparams));
            } else if (!self.user.tos_accepted) {
              top.location = '/find-picmonic';
            } else {
              var userAgent = navigator.userAgent || navigator.vendor || window.opera;
              var isMobileAndroidApp = userAgent.indexOf('Crosswalk') > -1 || userAgent.indexOf('CriOS') > -1;

              if (navigator.userAgent.indexOf('Crosswalk') > -1) {
                top.location =
                  $location.protocol() + '://' + $location.host() + (urlparams.redirect ? urlparams.redirect : '/home');
              } else if (
                !isMobileAndroidApp &&
                (!urlparams.redirect || (urlparams.redirect && urlparams.redirect.indexOf('typeform') !== 0)) &&
                ngBowser.isMobile()
              ) {
                top.location =
                  $location.protocol() +
                  '://' +
                  $location.host() +
                  '/login/mobile-app?redirect=' +
                  (urlparams.redirect ? urlparams.redirect : '/home');
              } else if (data.role == 'Affiliate') {
                top.location = '/affiliate-portal';
              } else if (data.role == 'Professor' || data.role == 'Administrator') {
                top.location = urlparams.redirect ? urlparams.redirect : '/home';
              } else if (urlparams.redirect) {
                if (urlparams.redirect.indexOf('/') === 0) {
                  urlparams.redirect = urlparams.redirect.substring(1);
                }
                if (urlparams.redirect.indexOf('%2F') === 0) {
                  urlparams.redirect = urlparams.redirect.substring(3);
                }
                top.location = '/' + urlparams.redirect;
              } else if (redirectUrl) {
                if (redirectUrl.indexOf('/') === 0) {
                  redirectUrl = redirectUrl.substring(1);
                }
                if (redirectUrl.indexOf('%2F') === 0) {
                  redirectUrl = redirectUrl.substring(3);
                }
                top.location = '/' + redirectUrl;
              } else {
                urlparams.browseOpen = 1;
                top.location = '/home?' + $.param(urlparams);
              }
            }
          }
        });
      },
      setMarketCookies: function (marketId) {
        var self = this,
          market = MarketOptionsConfig.getMarketById(marketId);

        if (market.is_pseudo) {
          self.setCookieIfNotLoggedIn('lead_secondary', marketId);
        } else {
          self.setCookieIfNotLoggedIn('lead', marketId);
        }

        self.setCookieIfNotLoggedIn('role', 'Student');
      },
      showRegisterModal: function (login, redirect, card, copy, market_id, extraParams) {
        return $modal.open({
          templateUrl: '/templates/modals/register-modal.html',
          windowClass: 'registration-cta-modal full-screen-modal',
          backdropClass: 'modal-body-reduced',
          controller: 'RegisterModalController',
          keyboard: false,
          resolve: {
            copy: function () {
              return copy ? copy : null;
            },
            card: function () {
              return card ? card : undefined;
            },
            tab: function () {
              return login ? 'login' : 'register';
            },
            redirect: function () {
              if (login && redirect === 'reload') {
                return 'reload';
              }

              if (login) {
                return null;
              }

              if (redirect) {
                return redirect;
              }

              if (card) {
                return '/learn/' + card.slug;
              }

              return '/find-picmonic';
            },
            market_id: function () {
              return market_id ? market_id : null;
            },
            extraParams: function () {
              return extraParams;
            },
          },
        });
      },
      see: function (key, increment) {
        var self = this,
          data = {};

        if ((!increment && self.seen(key)) || !self.user || !self.user.user_id) {
          return;
        }

        data[key] = 1;
        self.user.has_seen[key] = (self.user.has_seen[key] || 0) + 1;

        User.meta(
          { column: 'has_seen' },
          data,
          function (result) {
            self.user.has_seen = result;
            if (typeof atlasEvent !== 'undefined' && !increment) {
              atlasEvent('click', key);
            }
          },
          function () {}
        );
      },
      seen: function (key) {
        return this.user && this.user.has_seen && !!this.user.has_seen[key];
      },
      showTOSModal: function (split) {
        var self = this;
        var lti = self.user.lti && self.user.lti.lti_id;
        var template = lti ? (self.user.settings.set_email ? '-lti-reg' : '-lti') : '';

        return $modal.open({
          templateUrl: '/templates/modals/tos-modal' + template + '.html',
          backdrop: 'static',
          windowClass: split == 'b' ? 'registration-cta-modal full-screen-modal' : 'lti-tos',
          modalClass: '',
          keyboard: !lti,
          controller: [
            '$rootScope',
            '$scope',
            '$modal',
            'UserService',
            'User',
            'FacebookService',
            '$http',
            '$timeout',
            '$animate',
            function ($rootScope, $scope, $modal, UserService, User, FacebookService, $http, $timeout, $animate) {
              $scope.UserService = UserService;
              $scope.lti = lti;
              $scope.user = {
                password: '',
                resource: 'set_password',
              };
              $scope.market = MarketOptionsConfig.getMarketById(UserService.user.lead);
              $scope.years = [];
              var start_year = new Date().getFullYear();
              for (var a = 0; a < 10; a++) {
                $scope.years.push(start_year + a);
              }

              $scope.months = {
                1: 'January',
                2: 'February',
                3: 'March',
                4: 'April',
                5: 'May',
                6: 'June',
                7: 'July',
                8: 'August',
                9: 'September',
                10: 'October',
                11: 'November',
                12: 'December',
              };

              $scope.tab = 'register';

              if (lti) {
                atlasEvent('seen', 'lti_tos_modal');

                if (split === 'b') {
                  $scope.$watch(
                    function () {
                      return $scope.tab;
                    },
                    function (newValue) {
                      if (newValue !== 'register') {
                        $timeout(function () {
                          angular.element('.registration-cta-modal').removeClass('value-add-modal');
                        });
                      } else if (
                        newValue === 'register' &&
                        $scope.market &&
                        $scope.market.picmonics &&
                        $scope.market.facts
                      ) {
                        $timeout(function () {
                          angular.element('.registration-cta-modal').addClass('value-add-modal');

                          $timeout(function () {
                            angular.element('.animate-ls').each(function (index, element) {
                              $timeout(function () {
                                $animate.addClass(element, 'pls-animation-left-slide');
                              }, index * 150);
                            });
                          }, 500);
                        });
                      }
                    }
                  );
                }
              }

              $scope.login = function (type) {
                $rootScope.registerModal = type == 'link' ? { link: 1 } : { lti: true };
                UserService.showRegisterModal(true, 'close');
              };

              $scope.setEmail = function () {
                if ($scope.step1.$invalid || $scope.step1.$pending) {
                  return;
                }
                UserService.user.tos_accepted = 1;
                UserService.user.settings.set_email = 0;
                UserService.user.email = $scope.user.email;
                UserService.user.is_wk = lti == 4 ? 1 : 0;
                UserService.user.$update().then(function () {
                  $scope.tab = 'market';
                  atlasEvent('completed', 'lti-tos-modal');
                });
              };

              $scope.submitGoogleRegister = function () {
                $q(function (resolve, reject) {
                  gapi.auth2.authorize(
                    {
                      client_id: pls_config.google_client_id,
                      scope: 'email profile openid',
                      response_type: 'id_token permission',
                    },
                    function (response) {
                      if (response.error) {
                        if (register) {
                          reject(response);
                        } else {
                          window.location =
                            'https://accounts.google.com/o/oauth2/v2/auth?client_id=' +
                            pls_config.google_client_id +
                            '&response_type=code&scope=email profile openid&redirect_uri=' +
                            window.location.origin +
                            '/login/google';
                        }
                      } else {
                        resolve(response);
                      }
                    }
                  );
                }).then(function (data) {
                  var base64Url = data.id_token.split('.')[1];
                  var base64 = base64Url.replace('-', '+').replace('_', '/');
                  UserService.user.email = JSON.parse(window.atob(base64)).email;
                  UserService.user.$update().then(function () {
                    $scope.tab = 'market';
                    atlasEvent('completed', 'lti-tos-modal');
                  });
                });
              };

              $scope.submitSocialRegistration = function () {
                FacebookService.login().then(function (data) {
                  $http
                    .get('https://graph.facebook.com/me?fields=id,email&access_token=' + data.authResponse.accessToken)
                    .then(function (r) {
                      UserService.user.email = r.data.email;
                      UserService.user.$update().then(function () {
                        $scope.tab = 'market';
                        atlasEvent('completed', 'lti-tos-modal');
                      });
                    });
                });
              };

              $scope.submitMarket = function () {
                const parsedName = UserService.parseFullName($scope.user.full_name);
                UserService.user.first_name = parsedName['first_name'];
                UserService.user.last_name = parsedName['last_name'];
                UserService.user.password = $scope.user.password;
                UserService.role = $scope.user.role;
                UserService.user.$update().then(function () {
                  $scope.tab = 'school';
                  atlasEvent('completed', 'lti-tos-modal-2');
                });
              };

              $scope.submitSchool = function () {
                if ($scope.user.role === 'Professor') {
                  UserService.user.interests = $scope.user.interests;
                  UserService.user.link = $scope.user.link;
                  UserService.user.phone = $scope.user.phone;
                } else {
                  UserService.user.graduation_month = $scope.user.graduation_month;
                  UserService.user.graduation_year = $scope.user.graduation_year;
                }

                UserService.user.$update().then(function () {
                  $scope.$close();
                  atlasEvent('completed', 'lti-tos-modal-3');
                });
              };

              $scope.accept = function () {
                if (lti && UserService.user.settings.set_email && !$scope.pass.$valid) {
                  return;
                }

                if (!$scope.loading) {
                  $scope.loading = true;

                  // Update password
                  User.updatev3(
                    $scope.user,
                    function () {
                      UserService.user.tos_accepted = 1;
                      UserService.user.settings.set_email = 0;

                      // Update email and name
                      if (lti && $scope.user.email && $scope.user.full_name) {
                        UserService.user.email = $scope.user.email;
                        parsedName = UserService.parseFullName($scope.user.full_name);
                        UserService.user.first_name = parsedName['first_name'];
                        UserService.user.last_name = parsedName['last_name'];

                        UserService.user.$update().then(
                          function () {
                            $scope.$close();
                          },
                          function (error) {
                            $scope.error = error.data.message;
                          }
                        );
                      } else if ($scope.email) {
                        UserService.user.email = $scope.email;
                        UserService.user.$update().then(
                          function () {
                            $scope.$close();
                          },
                          function (error) {
                            $scope.error = error.data.message;
                          }
                        );
                      } else {
                        $scope.$close();
                      }
                      atlasEvent('completed', 'lti-tos-modal');
                    },
                    function (error) {
                      $scope.loading = false;
                      $scope.error = error.data.message;
                    }
                  );
                }
              };
            },
          ],
        });
      },
      parseFullName: function (fullName) {
        var first_name, last_name;

        if (fullName.indexOf(' ') === -1) {
          first_name = fullName;
          last_name = '';
        } else {
          first_name = fullName.substring(0, fullName.indexOf(' '));
          last_name = fullName.substring(fullName.indexOf(' ') + 1);

          first_name = first_name.charAt(0).toUpperCase() + first_name.slice(1);
          last_name = last_name.charAt(0).toUpperCase() + last_name.slice(1);
        }

        return { first_name: first_name, last_name: last_name };
      },
      getApiKey: function () {
        if ($location.search().api_key && $location.search().api_key !== 'null') {
          api_key = $location.search().api_key;

          try {
            window.localStorage.setItem('api_key', api_key);
          } catch (e) {}
        } else {
          try {
            api_key = window.localStorage.getItem('api_key');

            if (api_key === 'undefined') {
              api_key = null;
            }

            if (api_key === 'null') {
              window.localStorage.removeItem('api_key');
              api_key = null;
            }
          } catch (e) {
            api_key = null;
          }
        }

        return api_key;
      },
      deleteApiKey: function () {
        $location.search('api_key', null);
        delete $http.defaults.headers.common.Authorization;
        try {
          localStorage.removeItem('api_key');
        } catch (e) {}
      },
      getMobileAppUrl: function (platform, marketId) {
        var self = this,
          lead = null,
          url = '';

        if (self.user.user_id && self.user.lead) {
          lead = parseInt(self.user.lead, 10);
        } else if (marketId) {
          lead = parseInt(marketId, 10);
        } else {
          lead = $cookies.get('pls_user_lead');
          lead = lead ? parseInt(lead, 10) : null;
        }

        switch (lead) {
          case 100: // MD
          case 105: // PA
          case 109: // Pharmacy
          case 115: // PT
          case 116: // OT
            url =
              platform === 'ios'
                ? 'https://apps.apple.com/us/app/picmonic-medical-usmle-pance/id1468103617'
                : 'https://play.google.com/store/apps/details?id=com.picmonic.androidapp.medicine';
            break;
          case 103: // Pre-Health
          case 107: // K12
          case 112: // College
          case 113: // Paramedic
            url =
              platform === 'ios'
                ? 'https://apps.apple.com/us/app/picmonic-for-college/id1468975572'
                : 'https://play.google.com/store/apps/details?id=com.picmonic.androidapp.college';
            break;
          case 101: // RN
          case 202: // LPN
          case 203: // NP
            url =
              platform === 'ios'
                ? 'https://apps.apple.com/us/app/picmonic-nursing-medical-np/id1102493706'
                : 'https://play.google.com/store/apps/details?id=com.picmonic.androidapp';
            break;
          default:
            // Master list
            url =
              platform === 'ios'
                ? 'https://apps.apple.com/us/developer/picmonic-the-visual-learning-community/id1102493705'
                : 'https://play.google.com/store/search?q=picmonic&c=apps';
            break;
        }

        return url;
      },
      shouldShowFPTCta: function () {
        return this.user.premium_trial_eligible;
      },
      freemiumSplitTest: function () {
        return 'a';
        /*
        if (!this.user.user_id) {
          return 'a';
        }

        return this.user.approved_educator || SplitTestService.split('trial_status_block_design3', ['a', 'b']) === 'a'
          ? 'a'
          : 'b';
        */
      },
      upgradeCta: function () {
        return this.shouldShowFPTCta()
          ? 'TRY PREMIUM FREE'
          : this.user.is_referred && this.user.is_trial && !this.user.ever_paid_us_money
          ? 'UPGRADE now for 20% off'
          : 'Upgrade to Premium';
      },
      canSeeGlossary: function () {
        return (
          this.user.user_id &&
          ([100, 105, 203].indexOf(this.user.lead) > -1 || this.user.email.indexOf('@picmonic.com') > -1)
        );
      },
    };
  },
]);
